import { round, subtract } from "lodash";

export const calculateWeeklySpendDifference = (spend: number, efficiency: number) => {
  const difference = round(subtract(efficiency, spend), 2);
  return difference;
};
